import _ from 'underscore';

inventorySearchService.$inject = [
  '$timeout',
  'loggerService',
  'jsSdk.inventorySummary'
];

function formatSummaries(inventorySummaries) {
  let summaries = inventorySummaries.map(function(summary) {
    summary.venue.type = _.find(summary.venue.tags, {
      key: 'VENUE_TYPE'
    });

    summary.venue.type = summary.venue.type ? summary.venue.type.name : null;

    summary.venue.subtype = _.find(summary.venue.tags, {
      key: 'VENUE_SUB_TYPE'
    });

    summary.venue.subtype = summary.venue.subtype ? summary.venue.subtype.name : null;
    summary.inventory = _.filter(summary.days && summary.days.length ? summary.days[0].inventory : [], inv => inv.type !== 'COVER');
    summary.events = summary.days && summary.days.length ? summary.days[0].events : [];

    // If today has events
    // Show the first event.
    if (summary.events && summary.events.length > 0) {
      summary.event = summary.events[0];
    }

    summary.description = getDescription(summary);

    _.each(summary.inventory, function(i) {

      // Takes into account tax, tip, fees
      i.priceTotal = calculatePriceTotal(i);

      // Total price divided by users
      i.pricePerGuest = i.priceTotal / i.guests;

    });

    // Sort inventory within a venue by price per guest
    summary.inventory = _.sortBy(summary.inventory, function(i) {
      return i.pricePerGuest;
    });

    // Remove disables inventory
    summary.inventory = _.filter(summary.inventory, function(i) {
      return i.enable;
    });

    return summary;
  });
  summaries = _.filter(summaries, function(summary) {
    return summary.inventory.length > 0;
  });
  summaries = _.sortBy(summaries, function(summary) {
    return (summary.event) ? 0 : 1;
  });

  return summaries;
}

function calculatePriceTotal(inventory) {
  const base = (inventory.price) ? inventory.price : 0;
  const tax = (inventory.tax) ? base * inventory.tax : base * 0.07;
  const tip = (inventory.tip) ? base * inventory.tip : base * 0.20;

  return base + tax + tip;
}

function getDescription(summary) {
  let description = null;

  if (summary.venue.details && summary.venue.details.shortDescription) {
    description = summary.venue.details.shortDescription;
  }

  if (summary.event) {
    description = summary.event.description;
  }

  if (description && description.length > 240) {
    description = `${description.slice(0, 240)}...`;
  }

  return description;
}

export default function inventorySearchService($timeout, loggerService, jsSdkInventorySummary) {
  class InventorySearchService {
    getInventorySummaries(options, success, error) { //eslint-disable-line
      jsSdkInventorySummary.list(options)
        .then(response => {
          success(formatSummaries(response));
        })
        .catch(response => {
          loggerService.error(response);

          error(response);
        });
    }
  }

  return new InventorySearchService();
}



// WEBPACK FOOTER //
// ./src/services/inventorySearchService.js